import React, { useEffect, useState } from "react";
import { Phone, Calendar } from "lucide-react";

/**
 * Sticky CTA bar — mobile only, slides in after the user scrolls past the hero.
 * Keeps Book/Call within one tap reach for high mobile conversion.
 */
export default function MobileStickyCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let raf = 0;
    const onScroll = () => {
      if (raf) return;
      raf = window.requestAnimationFrame(() => {
        setVisible(window.scrollY > 600);
        raf = 0;
      });
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf) window.cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      className={`lg:hidden fixed left-3 right-3 z-40 transition-all duration-500 pb-[env(safe-area-inset-bottom)] ${
        visible
          ? "bottom-3 opacity-100 translate-y-0"
          : "-bottom-24 opacity-0 translate-y-4 pointer-events-none"
      }`}
      data-testid="mobile-sticky-cta"
      aria-hidden={!visible}
    >
      <div
        className="rounded-2xl p-2 flex items-center gap-2 glass-strong max-w-[calc(100vw-180px)] ml-0 mr-auto"
        style={{
          boxShadow:
            "0 10px 40px rgba(0,0,0,0.55), 0 0 30px rgba(57,255,20,0.08)",
        }}
      >
        <a
          href="tel:2149838371"
          className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-xl border border-white/15 text-white text-sm font-semibold active:scale-[0.98] transition-transform"
          data-testid="mobile-sticky-call"
          aria-label="Call Core Scale Agency"
        >
          <Phone className="w-4 h-4 text-[#39FF14]" aria-hidden="true" />
          Call
        </a>
        <a
          href="https://cal.com/erik-carlson/secret"
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-[#39FF14] text-black text-sm font-semibold active:scale-[0.98] transition-transform"
          data-testid="mobile-sticky-book"
          aria-label="Book a strategy call"
        >
          <Calendar className="w-4 h-4" aria-hidden="true" />
          Book Call
        </a>
      </div>
    </div>
  );
}
